import EnumSet from 'Services/enumSet'

interface IInterfaceRegion extends EnumSet {
  none: number
  globalColorMode: number
  requestCardView: number
  opportunityCardView: number
  negotiationCardView: number
  directoryCardView: number
}

export const interfaceRegionTypes = new EnumSet({
  none: { value: 0, description: 'Indefinido' },
  globalColorMode: { value: 1, description: 'Modo de cor global' },
  requestCardView: { value: 2, description: 'Lista de solicitações' },
  opportunityCardView: { value: 3, description: 'Lista de oportunidades' },
  negotiationCardView: { value: 4, description: 'Lista de negociações' },
  directoryCardView: { value: 5, description: 'Lista de fornecedores' },
}) as IInterfaceRegion

interface ICardView extends EnumSet {
  none: number
  list: number
  grid: number
  map: number
}

export const cardViewTypes = new EnumSet({
  none: { value: 0, description: 'Indefinido' },
  list: { value: 1, description: 'Modo lista' },
  grid: { value: 2, description: 'Modo grid' },
  map: { value: 3, description: 'Modo mapa' },
}) as ICardView

interface IColorMode extends EnumSet {
  none: number
  light: number
  dark: number
}

export const colorModeTypes = new EnumSet({
  none: { value: 0, description: 'Indefinido' },
  light: { value: 1, description: 'Tema claro' },
  dark: { value: 2, description: 'Tema escuro' },
}) as IColorMode

export default {
  interfaceRegionTypes,
  cardViewTypes,
  colorModeTypes,
}